window._ = require('lodash');
window.$ = window.jQuery = require('jquery');

/*
  Imports the routes and store and vue to use with the Vue module.
*/
import Vue from 'vue';

// 3rd party
import materialIcons from "material-design-icons/iconfont/material-icons.css";
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify,
    {
        theme: {
            primary: "#0091EA",
            secondary: "#C0CA33",
            accent: "#00BFA5",
            error: "#f44336",
            warning: "#ffeb3b",
            info: "#2196f3",
            success: "#4caf50"
        },
        options: {
            minifyTheme: function (val) {
                return val.replace(/[\s|\r\n|\r|\n]/g, "");
            }
        }
    }
);

// element-ui
import {Table, TableColumn, Pagination, Loading, Message, MessageBox, Notification, Upload, Button} from "element-ui";
import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/id";
import "@/scss/elementui-theme-chalk-common-var.scss";

locale.use(lang)
Vue.prototype.$ELEMENT = { size: "small" }
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Upload);
Vue.use(Button);
Vue.use(Loading.directive);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

import '@/components/index';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import '@/registerServiceWorker';
import eventBus from '@/common/Event';
import formatters from '@/common/Formatters';

Vue.config.productionTip = false;

Vue.use(formatters);
Vue.use(eventBus);

new Vue({
    router,
    store,
    eventBus,
    render: h => h(App)
}).$mount('#app');
